<template>
  <div id="app" class="seller-payment-report-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>{{ $t('Seller-Payment-Report') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom left offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list class="menu-list">
                  <v-list-tile v-if="PB === 'TRY'" @click="getListExcel()">
                    <v-list-tile-title>
                      Excel {{ $t('Download') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid class="page-container">
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat class="filter-card">
                    <v-card-text class="pb-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm6 pt-2 md2>
                          <tarihcomp
                            :etiket="$t('Starting-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBasla"
                            v-model="KayitTarihiBasla"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>
                          <tarihcomp
                            :etiket="$t('Finishing-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBitis"
                            v-model="KayitTarihiBitis"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 md2>
                          <div class="filter-actions">
                            <div v-if="load1">
                              <v-btn color="info" @click="getList()" fab small dark>
                                <v-icon>search</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="progress" class="progress-wrap">
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                                size="28"
                              ></v-progress-circular>
                            </div>

                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                small
                                @click="filtrele()"
                                color="info"
                                fab
                                dark
                              >
                                <v-icon>filter_list</v-icon>
                              </v-btn>
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>

                            <v-chip
                              v-if="filtrevarmi"
                              small
                              color="green"
                              text-color="white"
                              class="filter-chip"
                            >
                              <v-icon left small>check_circle_outline</v-icon>
                              {{ $t('Filter') }}
                            </v-chip>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <ReportTable
                    :headers="headers"
                    :items="itemssatis"
                    :loading="progress"
                    :has-searched="hasSearched"
                    :storage-key="'saticiodemeraporu_report_table'"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :rows-per-page-items="[20, 100]"
                    class="report-table-host"
                  >
                    <template slot="cell" slot-scope="slotProps">
                      <div
                        class="cell-click-area"
                        @click="onCellClick(slotProps.item, slotProps.column)"
                      >
                        {{ slotProps.value }}
                      </div>
                    </template>
                  </ReportTable>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="odemeRapor.Value.PNR_No" hide-details></pnrbul>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select
                                clearable
                                :items="itemssaticitip"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="odemeRapor.Value.SaticiTip"
                                :label="$t('Seller-Type')"
                                hide-details
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="odemeRapor.Value.SaticiTip"
                                :label="$t('Seller-Code')"
                                v-model="odemeRapor.Value.SaticiKod"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <cariaracomp
                                :etiket="$t('Accound-Code')"
                                :value="odemeRapor.Value.HesapKodu"
                                v-model="odemeRapor.Value.HesapKodu"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                :label="$t('Payment-Type')"
                                item-value="value"
                                item-text="text"
                                :items="odemeItems"
                                v-model="odemeRapor.Value.OdemeTipi"
                              ></v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-layout justify-space-between column>
                                <v-checkbox
                                  v-model="tumsirketler"
                                  :label="$t('All-Companies')"
                                  hide-details
                                ></v-checkbox>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="filtreiptal()">
                  {{ $t('cancel_button') }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="filtrekayit()">
                  {{ $t('Apply-Filters') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "../rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function createHeaders(vm) {
  return [
    { text: "PNR", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Seller-Type"), value: "SaticiTip", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Code"), value: "SaticiKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Seller"), value: "SaticiAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px" },
    { text: vm.$t("Period-v2") + "1", value: "Donem1", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Period-v2") + "2", value: "Donem2", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "BA", value: "BA", type: "text", align: "left", visible: true, sortable: true, minWidth: "90px" },
    { text: vm.$t("Accound-Code"), value: "HesapKodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Date"), value: "Tarih", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Document-Type"), value: "EvrakTipi", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Document-Type-v3"), value: "EvrakTipiAciklama", type: "text", align: "left", visible: true, sortable: true, minWidth: "200px" },
    { text: vm.$t("Amount"), value: "Tutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Currency"), value: "DovizCinsi", type: "text", align: "center", visible: true, sortable: true, minWidth: "110px" },
    { text: vm.$t("Currency-Amount"), value: "DovizTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Exchange-Rate-v2"), value: "Kur", type: "text", align: "center", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Credit-Card"), value: "CoKrediKartKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "170px" },
    { text: vm.$t("Name"), value: "Isim", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: vm.$t("Title"), value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Sales-Current-Code"), value: "SatisCariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "160px" },
    { text: vm.$t("Sales-Current-Title"), value: "SatisCariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Credit-Card-No"), value: "KrediKartNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "170px" }
  ];
}

function beforeMount() {}

export default {
  name: "SaticiOdemeRaporu",
  beforeMount,
  components: {
    tarihcomp,
    yetkidialog,
    hatadialog,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    cariaracomp,
    ReportTable
  },
  filters: {
    dateformat(t) {
      return helpers.dateformat(t);
    },
    moneyformat(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol(m) {
      return helpers.bakiyekontrol(m);
    }
  },
  data() {
    return {
      headers: [],
      hasSearched: false,
      PB: "TRY",
      tumsirketler: false,
      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      itemstarihtip: [
        { text: this.$t("Registration-Date"), value: 0 },
        { text: this.$t("Check-in-Date"), value: 1 },
        { text: this.$t("Check-out-Date"), value: 2 },
        { text: this.$t("Sales-Invoice-Date"), value: 3 },
        { text: this.$t("Commission-Invoice-Date"), value: 4 },
        { text: this.$t("Received-Invoice-Date"), value: 5 }
      ],
      itemskomisyon: [
        { text: this.$t("None"), value: false },
        { text: this.$t("Available"), value: true },
        { text: this.$t("All-v2"), value: null }
      ],
      tarihTip: 0,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,
      headerssatis: [],
      odemeItems: [
        { text: this.$t("All-v2"), value: 0 },
        { text: this.$t("Payments-Made"), value: 1 },
        { text: this.$t("Received-Returns"), value: 2 }
      ],
      odemeRapor: {
        Value: {
          PNR_No: null,
          SaticiTip: null,
          SaticiKod: null,
          HesapKodu: null,
          Tarih1: null,
          Tarih2: null,
          OdemeTipi: 0
        },
        Limit: null
      },
      Rapor: {
        PSirketNo: null,
        PCariSirket: null,
        PPNR_No: null,
        PPNR_ParaBirimi: "TL",
        PKayitTarihBas: null,
        PKayitTarihBit: null,
        PDonem1Bas: null,
        PDonem1Bit: null,
        PDonem2Bas: null,
        PDonem2Bit: null,
        PFatTarihBas: null,
        PFatTarihBit: null,
        PKomFatTarihBas: null,
        PKomFatTarihBit: null,
        PCariKod: null,
        PSaticiTip: null,
        PSaticiKod: null,
        PDosyaTip: null,
        PDosya: null,
        PAcente: null,
        PPNRBir: null,
        PCariHesapGrubu: null,
        PCariTip: null,
        PSaticiGrup: null,
        PSaticiIc_Dis: null,
        PTurOp: null,
        PFaturali: null,
        POpsiyon: null,
        PAnaTip: null,
        PCariAnaHesap: null,
        PIptalRaporu: null,
        PRezGrupID: null,
        PSatisGrubu: null,
        PSatisGrupTip: null,
        PSaticiOdemesiHesapla: null,
        PMasrafMerkezi: null,
        PAcenteDepartmanID: null,
        PPozisyonNo: null,
        PSatisFaturaNo: null,
        PMusteriOdemelilerHaric: null,
        PReferans: null,
        PSatisTip1: null,
        PSatisTip2: null,
        PSatisTip3: null,
        PSatisTip4: null,
        PGelenFatTarihBas: null,
        PGelenFatTarihBit: null,
        PProfilSablonId: null,
        PKomisyonFaturali: null,
        PGelenFaturali: null
      },
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      yok: false,
      itemssatis: [],
      itemsiade: [],
      itemsvoid: [],
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date")
          }
        }
      }
    };
  },
  computed: {
    dateRules() {
      return [(v) => !!v || this.$t("Please-select-a-date")];
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.headers = createHeaders(this);

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    const credentialsRaw = window.localStorage.getItem("credentials");
    if (credentialsRaw) {
      try {
        const credentials = JSON.parse(credentialsRaw);
        if (credentials && credentials.ParaBirimi) {
          this.PB = credentials.ParaBirimi;
        }
      } catch (error) {
        this.PB = "TRY";
      }
    }

    if (this.sayfayetki.Status !== true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc === true) {
            if (this.$validator && this.$validator.localize) {
              this.$validator.localize("en", this.dictionary);
            }

            if (this.prevRoute != null) {
              window.open("#" + this.prevRoute, "_self");
            } else {
              window.open("#/", "_self");
            }
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    onCellClick(item) {
      if (!item) {
        return;
      }
      this.git(item);
    },
    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable - " + baslik;
        this.snackbar = true;
      }
    },
    git(val) {
      const url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
      window.open(url, "_target");
    },
    filtrele() {
      this.dialogfiltre = true;
    },
    filtrekayit() {
      this.filtrevarmi = true;
      this.dialogfiltre = false;
      this.getList();
    },
    filtreiptal() {
      this.filtrevarmi = false;
      this.dialogfiltre = false;
      this.odemeRapor.Value.PNR_No = null;
      this.odemeRapor.Value.SaticiTip = null;
      this.odemeRapor.Value.HesapKodu = null;
      this.odemeRapor.Value.OdemeTipi = 0;
      this.odemeRapor.Value.SaticiKod = null;
      this.tumsirketler = false;
      this.getList();
    },
    validateDateRange() {
      if (!this.$refs.formgunluksatis.validate()) {
        return false;
      }

      const bastarih = new Date(this.KayitTarihiBasla);
      const bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      return false;
    },
    createReportParams() {
      this.odemeRapor.Value.Tarih1 = this.KayitTarihiBasla;
      this.odemeRapor.Value.Tarih2 = this.KayitTarihiBitis;

      const RaporParam = {};
      RaporParam.PNR_No = this.odemeRapor.Value.PNR_No;
      RaporParam.SaticiTip = this.odemeRapor.Value.SaticiTip;
      RaporParam.HesapKodu = this.odemeRapor.Value.HesapKodu;
      RaporParam.Tarih1 = this.odemeRapor.Value.Tarih1;
      RaporParam.Tarih2 = this.odemeRapor.Value.Tarih2;
      RaporParam.OdemeTipi = this.odemeRapor.Value.OdemeTipi;

      if (this.odemeRapor.Value.SaticiKod != null) {
        RaporParam.SaticiKod = this.odemeRapor.Value.SaticiKod.kod;
      } else {
        RaporParam.SaticiKod = null;
      }

      return {
        Value: RaporParam,
        Limit: null,
        tumSirketler: this.tumsirketler,
        sayfaAdi: this.$route.name
      };
    },
    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.hasSearched = true;
      this.progress = true;
      this.load1 = false;

      const params = this.createReportParams();

      tool.http_post(this, "SaticiOdemeRaporu", params)
        .then((response) => {
          if (response.body.Status === true) {
            this.itemssatis = response.body.data || [];
          } else {
            this.itemssatis = [];
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        })
        .catch((response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
        })
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    },
    getListExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.progress = true;
      this.load1 = false;

      const params = this.createReportParams();

      tool.api_post_FileDownload(this, "Coper/ExcelSaticiOdemeRaporu", params)
        .then((response) => {
          tool.CreateDownloadLink(response, "CoperSaticiOdemeRaporu.xlsx");
        })
        .catch((response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
        })
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    }
  }
};
</script>

<style scoped>
.seller-payment-report-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.filter-card {
  background: #ffffff;
  border-radius: 4px;
}

.filter-actions {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.progress-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.filter-chip {
  margin-left: 0;
}

.report-table-host {
  width: 100%;
}

.cell-click-area {
  display: block;
  width: 100%;
  min-height: 24px;
  cursor: pointer;
}

.menu-list {
  min-width: 340px;
}

@media (max-width: 960px) {
  .filter-actions {
    justify-content: flex-start;
  }
}
</style>